import { useState, } from 'react';
import { Order } from '../../../Types/Order';
import { makeCall } from '../../../Utility/makeCallText';
import { usdFormat } from '../../../Utility/usdFormat';
import { formatPhone, formatPhoneLink } from '../../../Utility/phoneNumberFormat';
import { useAppDispatch, useAppSelector } from '../../../hooks';
import { getOrderDetails, getOrders, setDeleteOrder } from './OrderSlice';
import { postReadyStamp } from './Helpers/postReadyStamp';
// import SignatureModal from 'Features/SalesDep/SignatureCanvas/SignatureModal';
// import SignerModal from 'Features/SalesDep/SignatureCanvas/SignerModal';
// import { uploadSignatureData } from './helpers/uploadSignatureData';
import { deleteOrder } from './Helpers/deleteOrder';
import { Signature } from './OrderReport';
import { logEvent } from 'firebase/analytics';
import { analytics } from '../../../firebase';
import { Button, Card, Col } from 'reactstrap';
import { Icon } from '@mui/material';
import { SwipeableList, SwipeableListItem, Type as SwipeableType } from 'react-swipeable-list';
import RightAction from './RightAction';
import Swal from "sweetalert2";
import 'sweetalert2/src/sweetalert2.scss';
import DeleteOrderModal from './DeleteOrderModal';
import { useNavigate, useNavigation } from 'react-router-dom';

type Props = {
    item: Order;
    // onDeleteSuccess: (orderID: string) => void;
    onError: (error: string) => void;
}

const RenderOrderItem = ({ item, onError }: Props) => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const [orderID, setOrderID] = useState<string>('');
    const [deleteModalOpen, setDeleteModalOpen] = useState<boolean>(false);
    const [selectedOrder, setSelectedOrder] = useState<Order | null>(null);
    const [signatureModalVisible, setSignatureModalVisible] = useState<boolean>(false);
    const [signatureBase64, setSignatureBase64] = useState<Signature>(null);
    const [signerModalVisible, setSignerModalVisible] = useState<boolean>(false);
    const [signerName, setSignerName] = useState<string | null>(null);
    const token = useAppSelector((state) => state.auth.token);
    const alertMessage = `Are you sure? This will permanently close Order# ${item.id}.`

    const onRefresh = () => {
        dispatch(getOrders({ page: 1 }));
    };

    const handleDeleteModal = async (orderID: string) => {
        setOrderID(orderID);
        setDeleteModalOpen(true);
        logEvent(analytics, 'delete_order_web', {
            name: 'delete order modal',
            description: 'User opened order delete menu'
        })
    };

    const handleSeeDetails = (item: Order) => {
        dispatch(getOrderDetails(item.id));
        // navigation.navigate('OrderDetail', { item })
        navigate(`/Orders+Bids/OrderDetail/${item.id}`, { state: { item } });
    };

    const handleSignatureModal = async (order: Order) => {
        setSelectedOrder(order);
        setSignatureModalVisible(true);
        logEvent(analytics, 'customer_signature_web', {
            name: 'signature modal',
            description: 'User pressed signature button'
        })
    };

    const handleSignatureConfirm = (sig: string) => {
        setSignatureBase64(sig);
        setSignatureModalVisible(false);
    };
    
    const handleSignatureModalDismiss = () => {
        setSignerModalVisible(true);
    };

    // const handleSignerConfirm = async (name: string) => {
    //     try {
    //         setSignerName(name);
    //         setSignerModalVisible(false);
    
    //         const result = await uploadSignatureData(signatureBase64, name, selectedOrder, token);
    //         console.log('RenderOrderItem Sig Upload:', result)
    //         if (!result.ack) {
    //             throw new Error(`Sig Upload Error: ${result.errorMessage}`);
    //         } else {
    //             onRefresh();
    //         };
    //     } catch (e: any) {
    //         console.error('RenderOrderItem Sig Upload:', e)
    //         onError(e);
    //     } finally {
    //         setSignatureBase64(null);
    //         setSignerName(null);
    //     }
    // };

    const handleReadyStamp = async (orderID: Order['id'], token: string) => {
        try {
            const result = await postReadyStamp(orderID, token);
            
            if (!result.ack) {
                onError(result.errorMessage);
            } else {
                onRefresh();
            };
        } catch (e: any) {
            onError(e);
        };
        logEvent(analytics, 'ready_stamp_web', {
            name: 'ready stamp',
            description: 'User pressed ready stamp'
        })

    };

    const handleDeleteOrder = async (
        orderID: string,
        token: string,
        value?: string | number,
        note?: string | undefined,
    ) => {
        try{
            setDeleteModalOpen(false)
    
            const result = await deleteOrder(orderID, token, value, note);
            console.log('RenderOrderItem DeleteOrder:', result);
            if (!result.ack) {
                onError(result?.errorMessage);
            } else {
                logEvent(analytics, 'close_order_web', {
                    name: 'Close Order Web',
                    description: 'Close Order Web',
                });
                dispatch(setDeleteOrder(orderID));
            };
        } catch (err: any) {
            onError(err);
        };
    };

    return (
        <div>
            <SwipeableList
                type={SwipeableType.IOS}
                fullSwipe
            >
                <SwipeableListItem
                    key={item.id}
                    trailingActions={
                        <RightAction 
                            onDelete={() => {
                                Swal.fire({
                                    title: 'Delete Order',
                                    text: alertMessage,
                                    icon: 'warning',
                                    showCancelButton: true,
                                    confirmButtonText: 'Delete',
                                    confirmButtonColor: 'red',
                                    showLoaderOnConfirm: false,
                                }).then((result) => {
                                    if (result.isConfirmed) {
                                        handleDeleteModal(item.id);
                                    };
                                });
                            }}
                        />
                    }
                >
                    <Card
                        style={{ 
                            display: 'flex', 
                            cursor: 'default', 
                            userSelect: 'none',
                            width: '100%',
                            alignItems: 'center'
                        }}
                    >
                        <div 
                            style={{ 
                                flex: 1, 
                                display: 'flex', 
                                textAlign: 'start', 
                                paddingInlineStart: 20,
                                paddingBlock: 10,
                                width: '100%' 
                            }}
                        >
                            <div style={{ flex: 1, display: 'block', padding: 5 }}>
                                <div>
                                    <span className='itemName fw-bold fs-4 d-block'>{`Order #:`}</span>
                                    <span className='fw-bold fs-4'>{item.id}</span>
                                </div>
                                <div>
                                    <span className='itemDescription d-block'>Cust: {item.customerName}</span>
                                    <span className='itemDescription d-block'>Cust #: {item.customerId}</span>
                                    <span className='itemDescription d-block'>Amount: {usdFormat.format(item.orderAmount)}</span>
                                    <span className='itemDescription d-block'>PO: {item.po}</span>
                                    <span className='itemDescription d-block'>Method: {item.description}</span>
                                    <span className='itemDescription d-block'>Placed: {item.dateOrder}</span>
                                    <span className='itemDescription d-block'>Required: {item.dateRequired}</span>
                                    <span className='itemDescription d-block'>Branch: {item.branchName}</span>
                                    <div>
                                        <span className='itemDescription'>Branch #: </span>
                                        <a 
                                            onClick={() => makeCall(formatPhoneLink(item.branchPhone))}
                                            style={{ color: '#1a73e8', textDecoration: 'underline', cursor: 'pointer' }}
                                        >
                                            {formatPhone(item.branchPhone)}
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <div style={{ flex: 1, display: 'block', padding: 5 }}>
                                <div>                                
                                    <span className='itemName fw-bold fs-4 d-block'>Status: </span>
                                    {
                                        item.statusMessage === 'Pending'
                                        ? <span style={{ fontWeight: 'bold', fontSize: 24 }}>{item.statusMessage} (Not Printed)</span>
                                        : item.statusMessage === 'In Process'
                                        ? <span style={{ fontWeight: 'bold', fontSize: 24 }}>{item.statusMessage} (Printed)</span>
                                        : <span style={
                                                item.statusMessage === 'Ready For Pickup' || item.statusMessage === 'Complete'
                                                ? { color: 'green', fontWeight: 'bold', fontSize: 24 }
                                                : item.statusMessage === 'Late'
                                                ? { color: 'red', fontWeight: 'bold', fontSize: 24 }
                                                : { fontWeight: 'bold', fontSize: 24 }
                                            }
                                        >
                                            {item.statusMessage}
                                        </span>
                                    }
                                </div>
                                <div>
                                    
                                    <Button
                                        className='mainButton fw-bold mt-3'
                                        onClick={() => handleSeeDetails(item)}
                                    >
                                        See Details
                                    </Button>
                                    {/* {!item.signed && item?.invoice && item.statusMessage === 'Complete' */}
                                    {!item.signed && item?.invoice && item?.reqSignature
                                    ? (
                                        <Button
                                            className='mainButton fw-bold d-block mt-3'
                                            style={{ background: 'limegreen', borderColor: 'limegreen' }}
                                            onClick={() => handleSignatureModal(item)}
                                        >
                                            Signature
                                        </Button>
                                    ) : item.signed 
                                    ? ( 
                                        <Button
                                            disabled
                                            className='cardButton fw-bold mt-3 d-block'
                                            style={{ background: 'grey', borderColor: 'grey' }}
                                        >
                                            <i className='fa fal-lg fa-check'></i>
                                            Signed
                                        </Button>
                                    ):(null)}
                                    {/* {item.description !== 'OVER THE COUNTER' && item.statusMessage === 'Order Being Picked' && ( */}
                                    {item.statusMessage === 'Order Being Picked' && (
                                        <Button
                                            className='mainButton fw-bold d-block mt-3'
                                            style={{ background: 'limegreen', borderColor: 'limegreen' }}
                                            onClick={() => handleReadyStamp(item.id, token)}
                                        >
                                            Ready Stamp
                                        </Button>
                                    )}
                                </div>
                            </div>
                        </div>
                    </Card>
                </SwipeableListItem>
            </SwipeableList>
            
            {/* <SignatureModal 
                visible={signatureModalVisible} 
                onClose={() => setSignatureModalVisible(false)}
                // order={selectedOrder}
                onConfirm={handleSignatureConfirm}
                onDismiss={handleSignatureModalDismiss}
            />
            <SignerModal
                visible={signerModalVisible}
                onClose={() => setSignerModalVisible(false)}
                onConfirm={handleSignerConfirm}
            /> */}
            {deleteModalOpen && 
                <DeleteOrderModal
                    visible={deleteModalOpen}
                    onClose={() => setDeleteModalOpen(false)}
                    onConfirm={handleDeleteOrder}
                    orderID={orderID}
                    token={token}
                />
            }
        </div>
    )
};

export default RenderOrderItem;